/* Herb to Bottle (PRD H9): pinned panel steps through the stages as the section scrolls. */
(function () {
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  function init(story) {
    if (story.dataset.ready) return;
    story.dataset.ready = '1';
    const pin = story.querySelector('.story__pin');
    const steps = [...story.querySelectorAll('[data-story-steps] li')];
    const frames = [...story.querySelectorAll('.story__frame')];
    const bar = story.querySelector('[data-story-bar]');
    if (!steps.length) return;
    let current = 0, ticking = false;
    const update = () => {
      ticking = false;
      if (getComputedStyle(pin).position !== 'sticky') return; // stacked layout on small screens
      const r = story.getBoundingClientRect();
      const total = story.offsetHeight - innerHeight;
      const p = Math.min(1, Math.max(0, -r.top / total));
      if (bar) bar.style.width = (p * 100) + '%';
      const n = Math.min(steps.length - 1, Math.floor(p * steps.length));
      if (n === current) return;
      current = n;
      steps.forEach((s, k) => s.classList.toggle('is-active', k === n));
      frames.forEach((f, k) => f.classList.toggle('is-active', k === n));
    };
    // Only listen while the section is near the viewport (doc 04: loaded only when near).
    let on = false;
    const onScroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
    new IntersectionObserver(es => es.forEach(e => {
      if (e.isIntersecting && !on) { on = true; addEventListener('scroll', onScroll, { passive: true }); update(); }
      else if (!e.isIntersecting && on) { on = false; removeEventListener('scroll', onScroll); }
    }), { rootMargin: '200px 0px' }).observe(story);
  }
  document.querySelectorAll('[data-story]').forEach(init);
  document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('[data-story]').forEach(init));
})();
